<template>
  <div class="placeholder">
    <el-form-item label="提示文字">
      <el-input v-model="component.properties.placeholder" placeholder="请输入提示文字" maxlength="60"/>
    </el-form-item>
  </div>
</template>

<script>
export default {
  name: 'attr-placeholder',
  props: ['component']
}
</script>

<style>
  .placeholder{
    border-top: 1px solid #ebebeb;
  }
</style>



// WEBPACK FOOTER //
// src/components/form/componentAttr/placeholder.vue